import { createClient } from '@supabase/supabase-js'

// Miljøvariabler
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables!')
}

// Supabase-klient
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

//
// ---------- TYPER ----------
//

// 🏪 Restaurant
export type Restaurant = {
  id: string;
  name: string;
  logo_url: string | null;
  description: string | null;
  is_active: boolean;
  created_at: string;
};

// 🍕 Variant-priser (ny tabell)
export type MenuItemPrice = {
  id: string;
  menu_item_id: string;
  size: 'liten' | 'medium' | 'stor';
  price: number;
};

// 🍽️ Menyelement
export type MenuItem = {
  id: string;
  restaurant_id: string;
  name: string;
  description: string | null;
  price: number;
  category: string | null;
  is_available: boolean;
  created_at: string;

  // relasjon til variantpriser
  menu_item_prices?: MenuItemPrice[];
};

// 🚗 Sjåfør
export type Driver = {
  id: string;
  name: string;
  age: number;
  phone: string;
  vehicle_type: 'bike' | 'moped' | 'car';
  status: 'pending' | 'approved' | 'active' | 'inactive';
  credits_earned: number;
  created_at: string;
};

// 📦 Bestilling
export type Order = {
  id: string;
  customer_name: string;
  customer_phone: string;
  customer_address: string;
  zone: string;
  delivery_fee: number;
  subtotal: number;
  total: number;
  status: 'pending' | 'assigned' | 'delivering' | 'completed' | 'cancelled';
  driver_id: string | null;
  coupon_code: string | null;
  created_at: string;
};

// 🧾 Bestillingslinje
export type OrderItem = {
  id: string;
  order_id: string;
  menu_item_id: string;
  size: 'liten' | 'medium' | 'stor';
  quantity: number;
  unit_price: number; // snapshot av pris
  created_at: string;
};

// 🛒 Dagligvarebutikk
export type GroceryStore = {
  id: string;
  name: string;
  logo_url: string | null;
  description: string | null;
  is_active: boolean;
  created_at: string;
};
